import i18next from 'i18next';

i18next.addResources('en', 'AdelphiSpiritReductions', {
  newSpiritReduction: 'Record new spirit reduction',
  period: 'Period',
  fillId: 'Fill ID',
  date: 'Date',
  operator: 'Operator'
});
